import * as FUNDINGS_ACTION from 'constant/action/fundings'
import { handleActions } from 'redux-actions'

const initialState = {
  fundings: [],
  fundingsCategory: 'Club',
  leagueWideFunding: [],
  searchResult: [],
  searchTerm: ''
}

export default handleActions(
  {
    [FUNDINGS_ACTION.UPDATE_FUNDINGS]: (state, action) => ({
      ...state,
      fundings: action.payload
    }),
    [FUNDINGS_ACTION.UPDATE_FUNDINGS_SEARCH_TERM]: (state, action) => ({
      ...state,
      searchTerm: action.payload
    }),
    [FUNDINGS_ACTION.UPDATE_FUNDINGS_SEARCH_RESULT]: (state, action) => ({
      ...state,
      searchResult: action.payload
    }),
    [FUNDINGS_ACTION.UPDATE_FUNDINGS_CATEGORY]: (state, action) => ({
      ...state,
      fundingsCategory: action.payload
    }),
    [FUNDINGS_ACTION.UPDATE_LEAGUE_WIDE_FUNDING]: (state, action) => ({
      ...state,
      leagueWideFunding: action.payload
    })
  },
  initialState
)
